(() => {
  'use strict';

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    const button = document.getElementById('back-to-top');
    if (!(button instanceof HTMLElement)) return;

    const thresholdAttr = button.getAttribute('data-scroll-threshold');
    const threshold = Math.max(0, parseInt(thresholdAttr || '400', 10) || 400);

    let ticking = false;
    let visible = false;

    const setVisible = (nextVisible) => {
      if (nextVisible === visible) return;
      visible = nextVisible;

      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      // prevent tabbing to hidden control
      if (visible) {
        button.removeAttribute('tabindex');
      } else {
        button.setAttribute('tabindex', '-1');
      }
    };

    const handleScroll = () => {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;
      setVisible(y >= threshold);
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
      },
      { passive: true }
    );

    button.addEventListener('click', (e) => {
      e.preventDefault();
      const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      try {
        window.scrollTo({ top: 0, left: 0, behavior });
      } catch {
        window.scrollTo(0, 0);
      }
    });

    // initial state
    setVisible(false);
    handleScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();



